import { deliveryDefaultValues } from '@/features/pos/components/CustomerProfile/form/constants/defaultValues'
import {
    FormDefaultValues,
    FormInput,
    PhoneInput,
} from '@/features/pos/components/CustomerProfile/form/types'
import CountryList from 'country-list-with-dial-code-and-flag'

export const getDefaultValues = (
    values: FormDefaultValues,
    defaultCountryCode: string
): FormInput => {
    const phone: PhoneInput = {
        flag: '',
        dialCode: '',
        number: values.phone?.number ?? '',
    }

    if (values.phone) {
        const country = values.phone.dialCode
            ? CountryList.findOneByDialCode(values.phone.dialCode)!
            : CountryList.findOneByCountryCode(defaultCountryCode)!

        phone.flag = country.flag
        phone.dialCode = values.phone.number.startsWith('+') ? '' : country.dialCode
    } else {
        const country = CountryList.findOneByCountryCode(defaultCountryCode)!

        phone.flag = country.flag
        phone.dialCode = country.dialCode
    }

    return { ...deliveryDefaultValues, ...values, phone }
}
